var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_1",
    "data-name": "Component 14 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.106,
    height: 84.951,
    viewBox: "0 0 92.106 84.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 92.106,
    height: 84.951,
    fill: "none",
    stroke: "#e0e1e5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97-2",
    "data-name": "Rectangle 97",
    width: 92.106,
    height: 84.951,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M80.2,74.388a44.974,44.974,0,1,0-69.141,0",
    transform: "translate(0.428 0.428)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 35.89,
    height: 15.952,
    rx: 2.425,
    transform: "translate(28.107 67.922)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x1: 11.719,
    transform: "translate(79.309 45.755)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x1: 12.203,
    transform: "translate(1.078 45.755)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 10.543,
    y2: 6.087,
    transform: "translate(7.103 62.156)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 5.79,
    y2: 10.028,
    transform: "translate(62.617 7.035)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y2: 11.67,
    transform: "translate(46.052 1.078)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 5.91,
    y2: 10.237,
    transform: "translate(23.698 7.035)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 10.381,
    y2: 5.994,
    transform: "translate(7.265 23.362)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 10.319,
    y2: 5.918,
    transform: "translate(74.822 62.365)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y1: 16.771,
    x2: 25.972,
    transform: "translate(52.218 26.894)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M37.443,34.534a7.339,7.339,0,1,1-3.871-9.63A7.339,7.339,0,0,1,37.443,34.534Z",
    transform: "translate(15.359 15.992)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47-2",
    "data-name": "Group 47",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243-2",
    "data-name": "Path 243",
    d: "M80.2,74.388a44.974,44.974,0,1,0-69.141,0",
    transform: "translate(0.428 0.428)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96-2",
    "data-name": "Rectangle 96",
    width: 35.89,
    height: 15.952,
    rx: 2.425,
    transform: "translate(28.107 67.922)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59-2",
    "data-name": "Line 59",
    x1: 11.719,
    transform: "translate(79.309 45.755)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60-2",
    "data-name": "Line 60",
    x1: 12.203,
    transform: "translate(1.078 45.755)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61-2",
    "data-name": "Line 61",
    x1: 10.543,
    y2: 6.087,
    transform: "translate(7.103 62.156)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62-2",
    "data-name": "Line 62",
    x1: 5.79,
    y2: 10.028,
    transform: "translate(62.617 7.035)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63-2",
    "data-name": "Line 63",
    y2: 11.67,
    transform: "translate(46.052 1.078)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64-2",
    "data-name": "Line 64",
    x2: 5.91,
    y2: 10.237,
    transform: "translate(23.698 7.035)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65-2",
    "data-name": "Line 65",
    x2: 10.381,
    y2: 5.994,
    transform: "translate(7.265 23.362)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66-2",
    "data-name": "Line 66",
    x2: 10.319,
    y2: 5.918,
    transform: "translate(74.822 62.365)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67-2",
    "data-name": "Line 67",
    y1: 16.771,
    x2: 25.972,
    transform: "translate(52.218 26.894)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244-2",
    "data-name": "Path 244",
    d: "M37.443,34.534a7.339,7.339,0,1,1-3.871-9.63A7.339,7.339,0,0,1,37.443,34.534Z",
    transform: "translate(15.359 15.992)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities4);
export default __webpack_public_path__ + "static/media/utilities4.115ab72092f769d2329b144894b036c6.svg";
export { ForwardRef as ReactComponent };